import React from 'react';
import { Form } from 'antd';
import type { FormProps } from 'antd';

export type AppFormProps = FormProps;

const AppForm = React.forwardRef<HTMLFormElement, AppFormProps>((props, ref) => {
  // Ant Design Form does not forward ref to the native form element in a typed way.
  // We keep the ref for compatibility and cast internally.
  return <Form ref={ref as any} {...props} children={props.children as any} />;
}) as unknown as React.ForwardRefExoticComponent<
  FormProps & React.RefAttributes<HTMLFormElement>
> & {
  Item: typeof Form.Item;
  List: typeof Form.List;
};

// `min-w-0` default so Form.Item can shrink when used as a flex/grid child.
// Without it, min-width: auto (= content size) prevents shrinking, which makes
// rows with multiple flex-1 fields overflow when inputs hold long values.
// No-op in non-flex/grid contexts (block elements already have min-width: 0).
const AppFormItem = (({ className, ...rest }: React.ComponentProps<typeof Form.Item>) => {
  const merged = ['min-w-0', className].filter(Boolean).join(' ');
  return <Form.Item {...rest} className={merged} />;
}) as unknown as typeof Form.Item;

AppForm.Item = AppFormItem;
AppForm.List = Form.List;

AppForm.displayName = 'AppForm';

export default AppForm;
